<template>
  <v-card flat class="settings-card">
    <v-container>
      <graph-and-grid
        Title="Unique Customers"
        DisplayingText="customer calls"
        :Headers="headers"
        ApiPath="/reporting"
        :SearchLocal="true"
        GetParamType="call"
        GetParamName="unique_customer"
      >
      </graph-and-grid>
    </v-container>
  </v-card>
</template>

<script>
import GraphAndGrid from "../../reports/shared/GraphAndGrid.vue";

export default {
  name: "UniqueCustomers",
  components: {
    GraphAndGrid
  },
  directives: {},
  data: function() {
    return {
      headers: [
        {
          text: "Customer",
          value: "customer",
          width: "25%"
        },
        {
          text: "Longest Call",
          value: "maxDuration",
          width: "18%"
        },
        {
          text: "Average Call",
          value: "avgDuration",
          width: "18%"
        },
        {
          text: "Total Calls",
          value: "count",
          width: "18%"
        },
        {
          text: "Last Call",
          value: "lastDate",
          width: "20%"
        },
        {
          text: "Action",
          value: "action",
          width: "1%"
        }
      ]
    };
  },
  computed: {},
  async created() {},
  methods: {},
  watch: {}
};
</script>

<style scoped lang="stylus"></style>
